import React from "react";
import BaseModal from "../../../../components/modals/BaseModal";

const ExitModal = ({ onExitWithoutSaving, onExitWithSaving, onClose, dataFromSnippet }) => {
  const onExitWithoutSavingInternal = () => {
    onExitWithoutSaving();
    onClose();
  };

  const onExitWithSavingInternal = () => {
    onExitWithSaving();
    onClose();
  };

  const headerChildren = (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold">{dataFromSnippet.headerTitle}</h2>
    </div>
  );

  const bodyChildren = (
    <div className="w-full flex flex-col gap-4">
      <p className="text-[12px] md:text-[14px] lg:text-[16px]">{dataFromSnippet.bodyMessage}</p>
      <div className="w-full flex gap-2 justify-between items-center flex-col-reverse md:flex-row">
        <button
          className="w-full md:w-auto text-[12px] md:text-[14px] px-2 py-1 rounded-md text-gray-400 hover:bg-gray-400 hover:text-white"
          onClick={onClose}
        >
          {dataFromSnippet.cancelText}
        </button>
        <div className="w-full md:w-auto gap-2 flex flex-col-reverse md:flex-row">
          <button
            className="w-full md:w-auto text-[12px] md:text-[14px] rounded-md px-2 py-1 border border-red-400 text-red-400 hover:bg-red-400 hover:text-white"
            onClick={onExitWithoutSavingInternal}
          >
            {dataFromSnippet.exitWithoutSaving}
          </button>
          <button
            className="w-full md:w-auto text-[12px] md:text-[14px] bg-ov-green text-white px-2 py-1 rounded-md  font-semibold hover:opacity-80"
            onClick={onExitWithSavingInternal}
          >
            {dataFromSnippet.exitWithSaving}
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <BaseModal
      headerChildren={headerChildren}
      bodyChildren={bodyChildren}
      onClose={onClose}
      width="w-3/4 md:w-3/4 lg:w-1/2 xl:w-[37%]"
      show={true}
    />
  );
};

export default ExitModal;
